<template lang="">
	<div id="gnb">
		<!-- <h1 class="logo"><img src="../images/logo_az.png" alt="AstraZeneca"></h1> -->
		<div class="user">
			<div class="name" v-if="adminName">{{ adminName }}님</div>
			<div class="logs_btn">
				<button type="button" class="btn_log" @click="logout">로그아웃</button>
			</div>
		</div>

		<nav class="nav">
			<ul>
				<li
					v-for="menu in adminMenuList"
					:class="{ on: activeMenu === menu.id }"
					@click="openMenu(menu)"
				>
					<a>{{ menu.name }}</a>
					<ul class="sub">
						<li
							v-for="subMenu in menu.subMenu"
							:key="subMenu.id"
							:class="{ on: activeSubMenu === subMenu.id }"
							@click.stop="toMenu(subMenu)"
						>
							<a>{{ subMenu.name }}</a>
						</li>
					</ul>
				</li>
			</ul>
		</nav>
	</div><!-- //LNB -->
</template>
<script>
import { mapActions } from 'vuex';

const adminAccountModule = 'adminAccountModule'

export default {
	data () {
		return {
			adminMenuList: [
				{
					id: 1,
					name: "관리자 관리",
					subMenu: [
					{ id: 1.1, name: "관리자 관리", route: "AdminAccountManageListPage", starter: "/admin/admin-account" }
					]
				},
				{
					id: 2,
					name: "회원 관리",
					subMenu: [
					{ id: 2.1, name: "회원 관리", route: "AccountManageListPage", starter: "/admin/account" }
					]
				},
				{
					id: 3,
					name: "게시판 관리",
					subMenu: [
					{ id: 3.1, name: "공지사항 리스트", route: "BoardNoticeManageListPage", starter: "/admin/board-notice" },
					{ id: 3.2, name: "FAQ 리스트", route: "FaqManageListPage", starter: "/admin/board-faq"},
					{ id: 3.3, name: "후원 활동 리스트", route: "SponsorManageListPage", starter: "/admin/sponsor" },
					{ id: 3.4, name: "기부후원 단체 리스트", route: "DonationGroupManageListPage", starter: "/admin/donation-group" },
					]
				},
				{
					id: 4,
					name: "상품 관리",
					subMenu: [
					{ id: 4.1, name: "캠페인 리스트", route: "CampaignManageListPage", starter: "/admin/campaign" },
					{ id: 4.2, name: "청첩장 리스트", route: "InvitationWeddingListPage", starter: "/admin/wedding-list" },
					{ id: 4.3, name: "부고장 리스트", route: "InvitationFuneralListPage", starter: "/admin/funeral-list" },
					{ id: 4.4, name: "캠페인 후원자 조회", route: "CampaignPaymentListPage", starter: "/admin/campaign-payment-list" }
					]
				},
				{
					id: 5,
					name: "기타 관리",
					subMenu: [
					{ id: 5.1, name: "카테고리 리스트", route: "CategoryManageListPage", starter: "/admin/category" },
					{ id: 5.2, name: "캠페인 카테고리 리스트", route: "CampaignCategoryManageListPage", starter: "/admin/campaign-category" },
					{ id: 5.3, name: "기부처 리스트", route: "DonationCategoryManageListPage", starter: "/admin/donation-category" },
					{ id: 5.4, name: "팝업 리스트", route: "PopupManageListPage", starter: "/admin/popup"},
					{ id: 5.5, name: "제휴기관 관리", route: "PartnerManageListPage", starter: "/admin/partner" },
					{ id: 5.6, name: "문의내역 관리", route: "InquiryManageListPage", starter: "/admin/inquiry" },
					{ id: 5.7, name: "거래처 관리", route: "MerchantManageListPage", starter: "/admin/merchant" }
					]
				},
			],
			activeMenu: 0,
			activeSubMenu: 0,
			// currentMenu: 1,

			adminName: localStorage.getItem('adminName')
		}
	},

	methods: {
		...mapActions(adminAccountModule, ['requestAdminLogout']),

		openMenu(menu) {
			if (this.activeMenu === menu.id) this.activeMenu = 0
			// else if (this.activeMenu === menu.id && Math.floor(this.activeSubMenu) === menu.id) this.activeMenu = this.currentMenu
			else this.activeMenu = menu.id;
		},

		toMenu(menu) {
			this.$router.push({ name: menu.route })
		},

		updateActiveSubMenu(currentPath) {
			const allSubMenus = this.adminMenuList.flatMap(menu => menu.subMenu);
			const sortedSubMenus = allSubMenus.sort((a, b) => b.starter.length - a.starter.length);
			const match = sortedSubMenus.find(sub => currentPath.startsWith(sub.starter));

			if (match) {
				this.activeSubMenu = match.id;
				this.activeMenu = Math.floor(match.id);
			} else {
				this.activeSubMenu = 0;
				this.activeMenu = 0;
			}
		},

		logout() {
			localStorage.removeItem('adminName');
			this.requestAdminLogout()
			this.$router.push({ name: 'AdminLoginPage' })
		}
	},

	watch: {
		$route(newRoute) {
			this.updateActiveSubMenu(newRoute.path);
			if (localStorage.getItem('adminName')) {
				this.adminName = localStorage.getItem('adminName')
			} else {
				this.adminName = "";
			}
		},
	},

	mounted() {
		this.updateActiveSubMenu(this.$route.path)
	}
}
</script>
<style lang="">

</style>